var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personaliser---Necklaces",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Necklaces---Customiser---main-screen---mais-op\\xE7\\xF5es---topo---lightbox",
    transform: "translate(-230.000000, -311.000000)",
    fill: "#37584F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(117.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.812155,140.998737 C150.679558,140.998737 150.546961,140.965055 150.430939,140.897692 C150.165746,140.746125 150,140.459832 150,140.156698 L150,125.842039 C150,125.370497 150.364641,125 150.828729,125 L161.171271,125 C161.635359,125 162,125.370497 162,125.842039 L162,140.156698 C162,140.459832 161.834254,140.746125 161.569061,140.897692 C161.303867,141.049259 160.972376,141.032418 160.723757,140.84717 L155.983425,137.647423 L151.276243,140.864011 C151.143646,140.948215 150.977901,140.998737 150.812155,140.998737 Z M155.983425,135.778096 C156.149171,135.778096 156.298343,135.828619 156.447514,135.912823 L160.325967,138.556824 L160.325967,126.684078 L151.640884,126.684078 L151.640884,138.590506 L155.519337,135.946504 C155.668508,135.828619 155.81768,135.778096 155.983425,135.778096 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.fe3256108d48834b966243bf86001f1b.svg";
export { ForwardRef as ReactComponent };